import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  bookFlights: {
    display: 'flex',
    flexDirection: 'column',
  },

  bannerNotification: {
    boxSizing: 'border-box',
  },
  modalContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 24,
    paddingRight: 40,
    boxSizing: 'border-box',
    width: '100%',

    '& button': {
      minWidth: 40,
      zIndex: 1,

      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },

    '& svg': {
      transform: 'scale(1.5)',
    },
    [Theme.breakpoints.up('sm')]: {
      minWidth: 508,
      marginBottom: '-20px',
    },
    [Theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
    [Theme.breakpoints.up('lg')]: {
      minWidth: 'auto',
      marginBottom: '-50px',
    },
  },
  container: {
    boxSizing: 'border-box',
    maxWidth: 1080,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    marginTop: 20,
    fontFamily: Theme.typography.base.regular,
    gap: 20,
    padding: '0px 20px',
    width: '100%',

    [Theme.breakpoints.up('sm')]: {
      gap: 30,
      padding: '0px 50px',
    },

    [Theme.breakpoints.up('xl')]: {
      gap: 40,
      padding: 0,
    },

    '& h1': {
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[7],
      paddingBottom: 0,
      margin: 0,
      color: Theme.palette.text.brand,

      [Theme.breakpoints.up('sm')]: {
        fontSize: Theme.typography.size[9],
      },
    },
    '& h2': {
      fontSize: Theme.typography.size[6.5],
      fontFamily: Theme.typography.base.regular,
      fontWeight: 400,
      backgroundColor: Theme.palette.gray[50],
      paddingBottom: 20,
      margin: 0,
      color: Theme.palette.text.body,

      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[7],
      },
    },

    '& .signup': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexDirection: 'column',
      [Theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
      },

      '& h2': {
        paddingBottom: 10,
      },
      '& p': {
        margin: 0,
        [Theme.breakpoints.up('xl')]: {
          fontSize: Theme.typography.size[3],
        },
      },
    },
    '& .loginButton': {
      whiteSpace: 'nowrap',
    },
    '& .signupButton': {
      backgroundColor: 'red',
    },
    '& .loginComponent': {
      fontSize: Theme.typography.size[6.5],
      fontFamily: Theme.typography.base.regular,
      fontWeight: 400,
      backgroundColor: Theme.palette.gray[50],
      paddingBottom: 20,
      margin: 0,
      color: Theme.palette.text.body,

      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[6.5],
      },
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[7],
      },
    },
    '& .loginSubtitle': {
      fontSize: Theme.typography.size[2],
      fontFamily: Theme.typography.base.regular,
      fontWeight: 400,
      backgroundColor: Theme.palette.gray[50],
      paddingBottom: 20,
      margin: 0,
      color: Theme.palette.text.body,
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[2],
      },
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
    },
  },
}));

export default useStyles;
